import type { FC, PropsWithChildren, ReactElement } from "react";
import React from "react";
import AppleSignIn from "react-apple-login";
import { Button } from "@/components/button/Button";
import { envBasedConfig } from "@/constants/env-based-config.constant";

interface AppleButtonProps {
  onClick?: (event: unknown) => void;

  disabled?: boolean;
}

interface AppleLoginProps {
  children: ReactElement | Array<ReactElement> | string;
  className?: string;

  /**
   * String contains redirect URL.
   * It will be used as web app redirect URL once sign in is successful.
   *
   * @example
   * match/1733105
   */
  state: string;
  onClick?: () => void;
}

// clientId is provided by the users team (they manage Apple)
const APPLE_CLIENT_ID = "de.motain.iliga.web";

const APPLE_REDIRECT_URI =
  typeof window === "undefined"
    ? "n/a during SSR"
    : `${envBasedConfig.webExperience}/apple/auth-callback`;

const AppleLogin: FC<PropsWithChildren<AppleLoginProps>> = ({
  children,
  className,
  state,
  onClick,
}): ReactElement | null => {
  return (
    <AppleSignIn
      clientId={APPLE_CLIENT_ID}
      redirectURI={APPLE_REDIRECT_URI}
      state={state}
      scope="name"
      responseMode="form_post"
      responseType="code id_token"
      render={(props: AppleButtonProps) => (
        <Button
          className={className}
          onClick={(event) => {
            onClick?.();
            props.onClick?.(event);
          }}
        >
          {children}
        </Button>
      )}
    />
  );
};

export { AppleLogin };
